// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lt-0";